// extracted by mini-css-extract-plugin
export default {"tag":"Tags_tag__lEQ94"};